import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';

export const useUpdateUserProfileSettingsMutation = () => {
  return useMutation({
    mutationFn: async ({
      userId,
      newSettings,
    }: {
      userId: string;
      newSettings: any;
    }) => {
      return axios.post(config.apiGateway.updateUserProfileSettings, {
        user_id: userId,
        newSettings,
      });
    },
  });
};
